/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const ExecuteEnum = {
    PUT_EXECUTE_COMM: '/system/execute'
};
